export function percentRoundingFilter() {
	'ngInject';
	return percentage => {
		percentage *= 100;
		if (percentage > 0 && percentage < 1) {
			return 1;
		} else if (percentage > 99 && percentage < 100) {
			return 99;
		} else {
			return Math.round(percentage);
		}
	};
}
